export const PACKAGE_PRODUCTS_ACTION_TYPES = {
  SET_PACKAGE_PRODUCTS: "package/SET_PACKAGE_PRODUCTS",
  SET_PACKAGE_PRODUCTS_ERRORS: "package/SET_PACKAGE_PRODUCTS_ERRORS",
  SET_IS_ADD_PRODUCTS_OPEN: "package/SET_IS_ADD_PRODUCTS_OPEN",
  SET_FILTERS_PRODUCTS: "package/SET_FILTERS_PRODUCTS",
  SET_FILTERS_PACKAGES: "package/SET_FILTERS_PACKAGES",
};
